class Form {
  constructor() {
    this.DOM = {
      button: document.querySelector('[data-form-validate-target="submit-button"]'),
      alert: document.querySelector('[data-form-validate-target="alert"]'),
      elms: document.querySelectorAll('input[required], textarea[required], select[required]')
    };
    this.#addEvent();
  }
  #addEvent() {
    if (this.DOM.button === null) return;
    for (const elm of this.DOM.elms) {
      elm.addEventListener('change', this.checkFormValidity.bind(this));
    }
  }
  checkFormValidity() {
    const isFormValid = [...this.DOM.elms].every(elm => elm.value.trim() !== '');
    const flag = !isFormValid
    this.DOM.button.disabled = flag;
    this.DOM.alert.style.display = flag ? "block" : "none";
  }
}
export default Form;